import { client } from '../../../../../common-utils/libraries/axios/axios';
import { buildUrl } from '@/common-utils/functions/restUtils';
import { SIM_CARDS } from '../apiUrls';
import simCardFields from '../../fields/simCardFields';

/**
 * @param root0
 * @param root0.offers
 * @returns Mapped data object
 */
function mapResponseData({ offers }) {
    const data = {};

    const mappedItems = offers.map((item) => {
        return {
            [simCardFields.SIM_OFFERS.UUID.key]: item[simCardFields.SIM_OFFERS.UUID.key],
            [simCardFields.SIM_OFFERS.DATA.key]: item[simCardFields.SIM_OFFERS.DATA.key],
            [simCardFields.SIM_OFFERS.DATA_UNIT.key]: item[simCardFields.SIM_OFFERS.DATA_UNIT.key],
            [simCardFields.SIM_OFFERS.DISPLAY_NAME.key]: item[simCardFields.SIM_OFFERS.DISPLAY_NAME.key],
            [simCardFields.SIM_OFFERS.PROVIDER_OFFER_NAME.key]: item[simCardFields.SIM_OFFERS.PROVIDER_OFFER_NAME.key],
            [simCardFields.SIM_OFFERS.RANK.key]: item[simCardFields.SIM_OFFERS.RANK.key],
            [simCardFields.SIM_OFFERS.SHORT_DISPLAY_NAME.key]: item[simCardFields.SIM_OFFERS.SHORT_DISPLAY_NAME.key],
            [simCardFields.SIM_OFFERS.SIM_PROVIDER_NAME.key]: item[simCardFields.SIM_OFFERS.SIM_PROVIDER_NAME.key]
        };
    });

    data.offers = mappedItems;
    return data;
}

const queryGetSimOffersToUpdate = (simCardId, enabled) => {
    return {
        queryKey: [SIM_CARDS.SIM_PLAN_LIST_TO_UPDATE.queryKey, simCardId],
        queryFn: async () => {
            const response = await client.get(buildUrl(SIM_CARDS.SIM_PLAN_LIST_TO_UPDATE.url, { uuids: simCardId }));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetSimOffersToUpdate;